export type VehicleReservationStatus =
  | "pending"
  | "approved"
  | "rejected"
  | "cancelled"
  | "deleted";

export interface VehicleReservation {
  id: number;
  applicantName: string;
  applicantPhone: string;
  communityName: string;
  reservationDate: string; // YYYY-MM-DD
  drivingTime: string; // "09:00 ~ 18:00"
  purpose: string;
  destination: string;
  driverName: string;
  driverPhone: string;
  status: VehicleReservationStatus;
  rejectReason?: string;
  createdAt: string; // YYYY-MM-DD
  vhclId?: number | null; // 배정 차량 ID
  vehicleName?: string | null; // 차종 (예: 스타렉스)
  vehicleNo?: string | null; // 차량번호 (예: 78보 3232)
}

export interface Vehicle {
  vhclId: number;
  vehicleName: string;
  vehicleNo: string;
}

// 배정 차량 표시용 라벨 (예: "스타렉스 (78보 3232)")
export const formatVehicleLabel = (r: {
  vehicleName?: string | null;
  vehicleNo?: string | null;
}): string =>
  r.vehicleName && r.vehicleNo ? `${r.vehicleName} (${r.vehicleNo})` : "-";

export const VEHICLE_STATUS_LABEL: Record<VehicleReservationStatus, string> = {
  pending: "대기",
  approved: "승인",
  rejected: "반려",
  cancelled: "취소",
  deleted: "삭제",
};

export const VEHICLE_STATUS_COLOR: Record<VehicleReservationStatus, string> = {
  pending: "bg-yellow-400 text-white",
  approved: "bg-green-500 text-white",
  rejected: "bg-red text-white",
  cancelled: "bg-gray-dull text-white",
  deleted: "bg-gray-300 text-white",
};

export const VEHICLE_STATUS_DOT_COLOR: Record<
  VehicleReservationStatus,
  string
> = {
  pending: "bg-yellow-400",
  approved: "bg-green-500",
  rejected: "bg-red",
  cancelled: "bg-gray-dull",
  deleted: "bg-gray-300",
};
